var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleClose,
          expression: "handleClose"
        }
      ],
      staticClass: "search-bar"
    },
    [
      _c(
        "div",
        {
          ref: "searchBarContainer",
          staticClass: "search-bar__input-container",
          attrs: { "data-bot": "searchbar" },
          on: {
            click: _vm.handleOpen,
            mouseenter: _vm.handleShowTooltip,
            mouseleave: _vm.handleHideTooltip
          }
        },
        [
          _c("CompassIcon", { attrs: { icon: "search" } }),
          _vm._v(" "),
          _c("input", {
            staticClass: "search-bar__input",
            attrs: {
              type: "search",
              placeholder: _vm.$t.__("common.actions.search")
            },
            on: { focus: _vm.handleOpen }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-up" } }, [
        _vm.showTooltip
          ? _c("div", { staticClass: "search-bar__tooltip" }, [
              _c(
                "span",
                { staticClass: "typographies-paragraph-small-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Rechercher")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "shortcut" }, [
                _vm._v(_vm._s(_vm.shortcut))
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-right" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "search-results-container",
                style: {
                  left: _vm.resultsContainerStyles.left + "px",
                  width: _vm.resultsContainerStyles.width + "px"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "search-results-container__input-container" },
                  [
                    _c("CompassIcon", { attrs: { icon: "search" } }),
                    _vm._v(" "),
                    _vm.showCompanyScan
                      ? _c("CompassTagInteractive", {
                          attrs: {
                            variant: "removable",
                            color: "light-gray",
                            modelValue: "Annuaire des sociétés",
                            valueLabel: _vm.$l10n.__("Annuaire des sociétés")
                          },
                          on: { "tag-remove": _vm.handleRemoveCompanyScan }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.query,
                          expression: "query"
                        }
                      ],
                      ref: "searchInput",
                      staticClass: "search-results-container__input",
                      attrs: {
                        placeholder: _vm.$t.__("common.actions.search"),
                        type: "search"
                      },
                      domProps: { value: _vm.query },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.query = $event.target.value
                          },
                          _vm.handleSearchQueryInput
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _vm.query.length > 0
                      ? _c("CompassIconButton", {
                          staticClass: "search-results-container__input-close",
                          attrs: { icon: "close" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.resetSearchResults($event)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "resultsWrapper",
                    staticClass: "search-results-container__wrapper"
                  },
                  [
                    !_vm.showCompanyScan
                      ? _c(
                          "div",
                          { staticClass: "search-results-container__results" },
                          [
                            _c("SearchBarFilters", {
                              attrs: {
                                currentFilter: _vm.currentFilter,
                                permissions: _vm.permissions
                              },
                              on: { change: _vm.handleFilterUpdate }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showLabelRecentlyOpened
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "search-results-container__recently-opened-items typographies-paragraph-small-semibold"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$l10n.__("Récemment ouverts")) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isLoading
                      ? _c(
                          "div",
                          _vm._l(3, function(index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "search-results-container__loader typographies-paragraph-medium-regular"
                              },
                              [
                                _c("CompassSkeleton", {
                                  staticClass:
                                    "search-results-container__loader-image",
                                  attrs: { variant: "square" }
                                }),
                                _vm._v(" "),
                                _c("CompassSkeleton", {
                                  staticClass:
                                    "search-results-container__loader-text",
                                  attrs: { lines: 2 }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showNoResultsMessage
                      ? _c(
                          "div",
                          {
                            staticClass: "search-results-container__no-results"
                          },
                          [
                            _c("CompassIcon", {
                              attrs: { size: "small", icon: "search-no-result" }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-regular"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Aucun résultat ne semble correspondre à votre recherche."
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.searchResultsTotal > 0 &&
                    !_vm.isSimilarResults &&
                    !_vm.isLoading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "search-results-container__totalCount typographies-paragraph-medium-regular"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "%d résultat",
                                    "%d résultats",
                                    _vm.searchResultsTotal,
                                    _vm.searchResultsTotal
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showLabelSimilarResults
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "search-results-container__results-similar typographies-paragraph-medium-regular"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$l10n.__("Vous cherchiez peut-être...")
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "resultsList",
                        staticClass: "search-results-container__results-wrapper"
                      },
                      [
                        _vm.isRecentlyOpenedItems &&
                        _vm.recentlyOpenedResults.length > 0 &&
                        !_vm.query &&
                        _vm.currentFilter.length === 0
                          ? _c("ResultsRecentlyOpened", {
                              attrs: { results: _vm.recentlyOpenedResults }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchResults.companies.count > 0
                          ? _c("SearchResultsCategory", {
                              attrs: {
                                results: _vm.searchResults.companies,
                                isFiltered: _vm.filtersAreSame(),
                                isSimilarResults: _vm.isSimilarResults
                              },
                              on: { "see-all": _vm.handleFilterUpdate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchResults.individuals.count > 0
                          ? _c("SearchResultsCategory", {
                              attrs: {
                                results: _vm.searchResults.individuals,
                                isFiltered: _vm.filtersAreSame(),
                                isSimilarResults: _vm.isSimilarResults
                              },
                              on: { "see-all": _vm.handleFilterUpdate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchResults.contacts.count > 0
                          ? _c("SearchResultsCategory", {
                              attrs: {
                                results: _vm.searchResults.contacts,
                                isFiltered: _vm.filtersAreSame(),
                                isSimilarResults: _vm.isSimilarResults
                              },
                              on: { "see-all": _vm.handleFilterUpdate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchResults.opportunities.count > 0
                          ? _c("SearchResultsCategory", {
                              attrs: {
                                results: _vm.searchResults.opportunities,
                                isFiltered: _vm.filtersAreSame(),
                                isSimilarResults: _vm.isSimilarResults
                              },
                              on: { "see-all": _vm.handleFilterUpdate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasDocumentResults
                          ? _c("SearchResultsCategory", {
                              attrs: {
                                results: _vm.documentsData,
                                groupBy: _vm.searchResults.documents.groupBy,
                                groupedResults: _vm.groupedDocumentsData,
                                minResults: _vm.minResults,
                                isFiltered: _vm.filtersAreSame(),
                                isSimilarResults: _vm.isSimilarResults
                              },
                              on: { "see-all": _vm.handleFilterUpdate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchResults.items.count > 0
                          ? _c("SearchResultsCategory", {
                              attrs: {
                                results: _vm.searchResults.items,
                                isFiltered: _vm.filtersAreSame(),
                                isSimilarResults: _vm.isSimilarResults
                              },
                              on: { "see-all": _vm.handleFilterUpdate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchResults.tickets.count > 0
                          ? _c("SearchResultsCategory", {
                              attrs: {
                                results: _vm.searchResults.tickets,
                                isFiltered: _vm.filtersAreSame(),
                                isSimilarResults: _vm.isSimilarResults
                              },
                              on: { "see-all": _vm.handleFilterUpdate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchResults.archived.count > 0 &&
                        _vm.currentFilter.length === 0
                          ? _c("SearchResultsCategory", {
                              attrs: { results: _vm.searchResults.archived }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.companyScanResults, function(result) {
                          return _c("SearchResultsCompanyScan", {
                            key: result.id,
                            attrs: {
                              name: result.name,
                              address: result.address,
                              siret: result.siret,
                              uuid: result.uuid
                            },
                            on: { createCompany: _vm.handleCreateCompany }
                          })
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.displayCompanyScanButton
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "search-results-container__company-scan-launch"
                          },
                          [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "search-results-container__company-scan-launch-title typographies-paragraph-small-semibold"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$l10n.__("Aller plus loin...")) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.$t.__(
                                  "searchbar.SearchBar.search_in_company_directory"
                                ),
                                type: "secondary",
                                size: "small",
                                "data-bot": "searchbar.company-scan-launch"
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleCompanyScan($event)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-results-container__footer" },
                      [
                        _c("div", {
                          staticClass: "search-results-container__footer-help"
                        }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "search-results-container__footer-actions"
                          },
                          [
                            _c(
                              "li",
                              {
                                staticClass:
                                  "typographies-paragraph-small-regular"
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$l10n.__("Naviguer")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "shortcut" },
                                  [
                                    _c("CompassIcon", {
                                      attrs: {
                                        size: "extra-small",
                                        icon: "caret-down-fill"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "shortcut" },
                                  [
                                    _c("CompassIcon", {
                                      attrs: {
                                        size: "extra-small",
                                        icon: "caret-up-fill"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "typographies-paragraph-small-regular"
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$l10n.__("Ouvrir")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "shortcut" },
                                  [
                                    _c("CompassIcon", {
                                      attrs: {
                                        size: "extra-small",
                                        icon: "keyboard-enter"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "typographies-paragraph-small-regular"
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$l10n.__("Fermer")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "shortcut" },
                                  [
                                    _c("CompassIcon", {
                                      attrs: {
                                        size: "extra-small",
                                        icon: "keyboard-esc"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showCompanyCreateDialog
        ? _c("SearchBarCompanyCreateDialog", {
            attrs: {
              companyToCreate: _vm.companyToCreate,
              countryCode: _vm.countryCode
            },
            on: { close: _vm.handleCloseCompanyCreateDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }